module.exports = __webpack_public_path__ + "static/img/gycz.10f1630c.png";